/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import {Spinner, TextInput} from '@volkswagen-onehub/components-core';
import React, {useEffect, useState} from 'react';
import BodyText from '../components/BodyText';
import Div from '../components/Div.styled';
import DropdownSelect from '../components/DropdownSelect';
import Icon from '../components/Icon';
import QuestionContentWrapper from '../components/QuestionContentWrapper';
import SpaceLike from '../components/Space';
import InputWrapperWithLabel from '../components/StyledInputWrapperWithLabel';
import TypographyBody from '../components/Typography/TypographyBody';
import TypographyHeading from '../components/Typography/TypographyHeading';
import {postcode_data_sample} from '../constants/questions';
import {config} from '../environment';
import {convertDataForQuestionManualFour} from '../helpers/questionManualTransformData';
import useMediaQuery from '../hooks/useMediaQuery';
import useQuestionStore from '../store/navigation';
import {useResultStore} from '../store/responses';
import {useSalesForceObjectStore} from '../store/salesforce';
import {QUESTIONIDS, Question} from '../types/question';
import {ResultQuestionFour, ResultVehicle} from '../types/questionManuals';
import {TradeInEvaluation} from '../types/salesforce';
import {SurveyResponse} from '../types/surveyResponse';
import {sendAnalyticPayload} from '../utils/analytic';

interface VehicleSelected {
  value: string;
  makeCode: string;
  familyCode: string;
  year: string;
  month: string;
  rbc: string;
  rego: string;
  state: string;
  make?: string;
}

function QuestionTwoYourVehicle(props: Question) {
  const {
    nextStepId,
    title,
    setStepManual,
    showResultVehicle,
    onShowResultVehicle,
  } = props;
  const {isMobile} = useMediaQuery();
  const [titlePage, setTitlePage] = useState(title);
  const [vehicleSelected, setVehicleSelected] =
    useState<VehicleSelected | null>(null);
  const [vehicleResult, setVehicleResult] = useState<ResultVehicle | null>(
    null,
  );
  const [tradeInEvaluationState, setTradeInEvaluationState] =
    useState<TradeInEvaluation | null>(null);
  const [loadingVariantSelected, setLoadingVariantSelected] = useState(true);

  const {
    setCurrentQuestion,
    setQuestionType,
    currentQuestion,
    setQuestionHistory,
  } = useQuestionStore();
  const {updateQuestion, result} = useResultStore();
  const {setTradeInEvaluation} = useSalesForceObjectStore();

  const {rego, state} = result[QUESTIONIDS.questionTwoYourVehicle] || {};
  const [registrationNumber, setRegistrationNumber] = useState<string>(
    rego || '',
  );
  const [registrationState, setRegistrationState] = useState<
    SurveyResponse[typeof QUESTIONIDS.questionTwoYourVehicle]['state']
  >(state || '');

  const handleChange = (event: React.SyntheticEvent<HTMLInputElement>) => {
    const target = event.target as HTMLInputElement;
    setRegistrationNumber(target.value);
  };

  const handleSelectOption = (value?: string) => {
    setRegistrationState(value as typeof registrationState);
  };
  useEffect(() => {
    setTitlePage(
      showResultVehicle
        ? vehicleResult && vehicleSelected
          ? 'Nice, are these details correct?'
          : !loadingVariantSelected && !vehicleSelected
          ? `Apologies, we didn't find any results`
          : 'Nice, are these details correct?'
        : title,
    );
  }, [
    loadingVariantSelected,
    showResultVehicle,
    title,
    vehicleResult,
    vehicleSelected,
  ]);

  const onSubmit = async () => {
    if (!showResultVehicle) {
      setLoadingVariantSelected(true);
      updateQuestion({
        id: QUESTIONIDS.questionTwoYourVehicle,
        value: {
          rego: registrationNumber,
          state: (registrationState ?? '') as NonNullable<
            typeof registrationState
          >,
        },
      });
      onShowResultVehicle?.();
    } else {
      setTradeInEvaluation(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        convertResultToTradeInEvaluation(tradeInEvaluationState!),
      );
      updateQuestion({
        id: QUESTIONIDS.questionTwoYourVehicle,
        value: {
          rego: registrationNumber,
          state: (registrationState ?? '') as NonNullable<
            typeof registrationState
          >,
          value: vehicleResult?.description || '',
        },
      });
      setCurrentQuestion(nextStepId);
      sendAnalyticPayload({
        process: {StepName: currentQuestion, StepNumber: '1'},
        product: {
          Manufacturer: vehicleSelected?.make || '',
          Name: vehicleSelected?.familyCode || '',
        },
      });
    }
  };
  console.log(loadingVariantSelected);
  useEffect(() => {
    if (showResultVehicle) fetchVariant();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showResultVehicle]);
  const fetchVariant = async () => {
    try {
      if (rego && state) {
        const questionThreeData = await fetch(
          `${config.API_REDBOOK_REGO_DETAILS_URL}`,
          {
            method: 'POST',
            body: JSON.stringify({
              rego: rego,
              state: state,
            }),
            headers: {'Content-Type': 'application/json'},
            mode: 'cors',
          },
        );

        const result: {data: ResultQuestionFour[]} =
          await questionThreeData.json();
        if (result && result.data) {
          const transformedData = convertDataForQuestionManualFour(result.data);
          const variantSelect = transformedData[0];
          const variant = {
            value: variantSelect.description,
            makeCode: variantSelect.makecode,
            familyCode: variantSelect.familycode,
            year: variantSelect.year,
            month: variantSelect.month,
            rbc: variantSelect.rbc,
            rego: registrationNumber || '',
            state: registrationState || '',
            make: variantSelect.make || '',
          };
          fetchVehicleSelected(variant);
          setVehicleSelected(variant);
        } else {
          setLoadingVariantSelected(false);
          setVehicleSelected(null);
          setVehicleResult(null);
        }
      }
    } catch (error) {
      setLoadingVariantSelected(false);
      setVehicleSelected(null);
      setVehicleResult(null);
      console.error('Error fetching data:', error);
    }
  };
  const fetchVehicleSelected = async (vehicleSelected: VehicleSelected) => {
    try {
      if (vehicleSelected) {
        const speficicationResponse = await fetch(
          `${config.API_REDBOOK_SPECIFICATION_URL}`,
          {
            method: 'POST',
            body: JSON.stringify({
              makecode: vehicleSelected.makeCode,
              familycode: vehicleSelected.familyCode,
              year: parseInt(vehicleSelected.year as string),
              month: parseInt(vehicleSelected.month as string),
              rbc: vehicleSelected.rbc,
            }),
            headers: {'Content-Type': 'application/json'},
            mode: 'cors',
          },
        );

        const result: {data: ResultVehicle} =
          await speficicationResponse.json();

        if (result.data) {
          setVehicleResult(result.data);
          setTradeInEvaluationState(
            result.data as unknown as TradeInEvaluation,
          );
          setLoadingVariantSelected(false);
        } else {
          setLoadingVariantSelected(false);
          setVehicleSelected(null);
          setVehicleResult(null);
        }
      }
    } catch (error) {
      setVehicleResult(null);
      setVehicleSelected(null);
      setLoadingVariantSelected(false);
      console.error('Error fetching data:', error);
    }
  };

  function convertResultToTradeInEvaluation(
    data: TradeInEvaluation,
  ): TradeInEvaluation {
    return {
      ...data,
      rego_no: registrationNumber || '',
      state: registrationState || '',
      make: vehicleSelected?.make || '',
      model: vehicleSelected?.familyCode || '',
      variant: vehicleSelected?.value || '',
    };
  }

  const renderField = (id: string, value: string) => {
    if (value) {
      return (
        <TypographyBody
          key={id}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            margin: 0,
            fontSize: 16,
            fontWeight: 400,
          }}
        >
          <Icon
            icon={
              (getIcon(id) as
                | 'car-private'
                | 'info'
                | 'chevron-down'
                | 'chevron-up'
                | 'arrow-back'
                | 'arrow-right-alt'
                | 'calendar'
                | 'engine'
                | 'transmission') || 'car-private'
            }
            color="white"
            style={{cursor: 'pointer', marginRight: 16}}
          />
          {value}
        </TypographyBody>
      );
    }
    return null;
  };

  const getIcon = (id: string) => {
    const iconMap: Record<string, string> = {
      carPrivate: 'car-private',
      engine: 'engine',
      calendar: 'calendar',
      transmission: 'transmission',
    };

    return iconMap[id] || '';
  };
  return (
    <QuestionContentWrapper
      title={
        !(showResultVehicle && loadingVariantSelected) ? titlePage : undefined
      }
      handleClick={onSubmit}
      maxWidthContent={800}
      disabled={
        !registrationState ||
        !registrationNumber ||
        (showResultVehicle && loadingVariantSelected)
      }
    >
      <Div>
        {!showResultVehicle && (
          <Div maxWidth="400px">
            <form>
              <Div margin="0 0 16px">
                <DropdownSelect
                  value={registrationState}
                  onSelect={handleSelectOption}
                  label="Registration state"
                  options={postcode_data_sample}
                />
              </Div>
              <InputWrapperWithLabel>
                <TextInput
                  value={registrationNumber}
                  appearance={'default'}
                  type="text"
                  placeholder="Please enter"
                  onChange={handleChange}
                  label="Registration number"
                />
              </InputWrapperWithLabel>
            </form>
            <TypographyBody
              style={{
                fontSize: 16,
                fontWeight: 400,
              }}
              color="white"
            >
              {' '}
              No registration plates?{' '}
              <span
                style={{
                  textDecorationSkipInk: 'none',
                }}
                className="button-text"
                onClick={() => {
                  setStepManual?.(1);
                  setQuestionHistory(currentQuestion, `manual-step-${1}`);
                  setQuestionType('Manual');
                }}
              >
                Select your vehicle manually
              </span>
            </TypographyBody>
            <TypographyBody
              style={{
                marginTop: '60px',
                fontSize: 16,
                fontWeight: 400,
              }}
              color="white"
            >
              {' '}
              Don&apos;t have a car?{' '}
              <span
                style={{
                  textDecorationSkipInk: 'none',
                  cursor: 'pointer',
                }}
                className="button-text"
                onClick={() => setCurrentQuestion(nextStepId)}
              >
                Please continue here
              </span>
            </TypographyBody>
          </Div>
        )}
        {showResultVehicle && (
          <Div maxWidth="800px">
            <Div margin="0 0 60px 0">
              {vehicleResult &&
                vehicleSelected?.rego &&
                vehicleSelected?.state &&
                !loadingVariantSelected && (
                  <React.Fragment>
                    <TypographyHeading
                      tag="h3"
                      bold
                      size="medium"
                      textAlign="center"
                    >
                      {vehicleResult &&
                        `${vehicleSelected?.make} ${vehicleResult?.familycode} ${vehicleResult?.badge} ${vehicleResult?.year}`}
                    </TypographyHeading>
                    <TypographyBody
                      size="body"
                      textAlign="center"
                      style={{marginTop: '12px'}}
                    >
                      {vehicleSelected?.rego + ' | ' + vehicleSelected?.state}
                    </TypographyBody>
                  </React.Fragment>
                )}
            </Div>

            <Div
              customStyles={{
                height: '100%',
                maxWidth: '400px',
                margin: '0 auto',
              }}
            >
              {loadingVariantSelected ? (
                <Div width="100%" customStyles={{textAlign: 'center'}}>
                  <Spinner variant="large" />
                </Div>
              ) : vehicleResult && vehicleSelected ? (
                <SpaceLike
                  width="100%"
                  direction="vertical"
                  size={32}
                  customStyles={{
                    border: '1px solid #fff',
                    borderRadius: 8,
                    maxWidth: 400,
                    padding: '40px 32px',
                    width: '100%',
                    marginBottom: '24px',
                  }}
                >
                  {renderField('calendar', vehicleResult?.year || '')}
                  {renderField('transmission', vehicleResult?.geartype || '')}
                  {renderField('engine', vehicleResult?.fueltype || '')}
                  {renderField(
                    'carPrivate',
                    vehicleResult?.bodyconfig || vehicleResult.bodystyle || '',
                  )}
                </SpaceLike>
              ) : (
                <></>
              )}
              {!(showResultVehicle && loadingVariantSelected) ? (
                <BodyText size="16px">
                  Something isn’t right?{' '}
                  <span
                    style={{
                      textDecorationSkipInk: 'none',
                      cursor: 'pointer',
                      display: isMobile ? 'block' : 'inline',
                    }}
                    className="button-text"
                    onClick={() => {
                      setStepManual?.(1);
                      setQuestionHistory(currentQuestion, `manual-step-${1}`);
                      setQuestionType('Manual');
                    }}
                  >
                    Select your vehicle manually.
                  </span>
                </BodyText>
              ) : (
                <></>
              )}
            </Div>
          </Div>
        )}
      </Div>
    </QuestionContentWrapper>
  );
}

export default QuestionTwoYourVehicle;
